export function isAndroid() {
  return -1 < navigator.userAgent.toLowerCase().indexOf("android");
}

export function isIOS() {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

export function isMobile() {
  return !!(isTouch() && screen.width < 600);
}

export function isTablet() {
  return !!(isTouch() && 600 <= screen.width);
}

export function isTouch() {
  return Boolean("ontouchstart" in window || navigator.maxTouchPoints);
}


export function getWindowScrollTop() {
  return window.pageYOffset ||(document.documentElement || document.body.parentNode || document.body).scrollTop;
}

export function isInViewport(el) {
  const bounding = el.getBoundingClientRect();
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const vertInView = (bounding.top <= windowHeight) && ((bounding.top + bounding.height) >= 0);
  const horInView = (bounding.left <= windowWidth) && ((bounding.left + bounding.width) >= 0);

  return (vertInView && horInView);
}

export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/* throttle from underscore */
export function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : new Date();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export function detectIEEdge() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE '); // <= IE10
  const trident = ua.indexOf('Trident/'); // IE11
  const edge = ua.indexOf('Edge/'); // Edge

  if (msie > 0 || trident > 0 || edge > 0) {
    return true;
  }

  return false;
}
